import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const OrderSuccessDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const PharmacyContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flex: 1,
  },
}));

export const OrderSumaryContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flex: '0 0 40%',
  },
}));
